export default __webpack_public_path__ + "static/media/registro.29569e30.jpg";